export default __webpack_public_path__ + "static/media/Conscript's Legguards of the Ascending Kingdom.6ebd3f06.jpg";